import { withDisplayCurrency } from "@/features/display-currency/display-currency.utils";
import { useDisplayCurrency } from "@/features/display-currency/useDisplayCurrency";
import { QueryHookOptions, useQuery } from "@apollo/client";
import searchProductsGql from "@whoppah/apollo/query/searchProducts.graphql";
import {
  SearchProductsQuery,
  SearchProductsQueryVariables,
} from "@whoppah/apollo/schema";

const useSearchProducts = (
  options?: QueryHookOptions<SearchProductsQuery, SearchProductsQueryVariables>
) => {
  const currency = useDisplayCurrency();

  return useQuery(searchProductsGql, withDisplayCurrency(options, currency));
};

export default useSearchProducts;
